import React from "react"
import {
  StaticReviewBlockOutput,
  StaticReviewOutput,
} from "contexts/settings/Integrations/integrationsSettings-types"

export const useStaticReviewData = (
  staticReviews: StaticReviewOutput[] | StaticReviewBlockOutput
) => {
  let hasMoreThan1Review: boolean = false

  if (staticReviews instanceof Array) {
    hasMoreThan1Review = staticReviews.length > 1
    const { heading } = staticReviews[0]

    return {
      hasMoreThan1Review,
      heading,
      reviews: staticReviews,
      subHeading: "",
    }
  }

  const { heading, reviews, sub_heading } = staticReviews

  hasMoreThan1Review = reviews.length > 1

  return {
    hasMoreThan1Review,
    heading,
    reviews,
    subHeading: sub_heading,
  }
}
